import { SalesPartnerCreateCustomerLanguageEnum } from "@/services/model/salesPartnerCreateCustomerLanguageEnum";

// Helper function to map language enum to translation key
export const getLanguageTranslationKey = (enumValue: string) => {
  const mapping: Record<string, string> = {
    [SalesPartnerCreateCustomerLanguageEnum.DE]: "1",
    [SalesPartnerCreateCustomerLanguageEnum.EN]: "2",
    [SalesPartnerCreateCustomerLanguageEnum.FR]: "3",
  };

  return mapping[enumValue] || enumValue;
};
